const getFirstCharsOfName = (name) => {
  if (!name) return
  const nameArray = name.split(' ')
  const firstName = nameArray[0]
  const lastName = nameArray[nameArray.length - 1]
  const firstCharsOfFirstName = firstName ? firstName.slice(0, 1) : ''
  const firstCharsOfLastName = lastName ? lastName.slice(0, 1) : ''
  return `${firstCharsOfFirstName}${firstCharsOfLastName}`.toUpperCase()
}

const calculateReadingTime = (text) => {
  const wordsPerMinute = 200
  let textLength = text.split(/\s+/).length // splits the text by spaces and returns an array of words
  let value = Math.ceil(textLength / wordsPerMinute)
  return value + (value === 1 ? ' min read' : ' mins read')
}
const getPreviousWeekDates = () => {
  const currentDate = new Date()
  const daysInWeek = 7
  const dates = []
  for (let i = 0; i < daysInWeek; i++) {
    const date = new Date(currentDate)
    date.setDate(currentDate.getDate() - i) // Subtracting i days from the current date
    dates.push(formatDateForXAxis(date)) // Format for X-axis
  }
  return dates.reverse()
}

const formatDateForXAxis = (date) => {
  const day = date.getDate()
  const monthAbbreviation = date.toLocaleString('default', { month: 'short' })
  return `${day} ${monthAbbreviation}`
}

const getWordsCount = (string) => {
  return string.split(/\s+/).filter(Boolean).length
}

const createHubspotContact = async (contact) => {
  try {
    const createContact = await fetch('/api/create-hubspot-contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contact),
    })
    const con = await createContact.json()
    // console.log(con)
    return con
  } catch (err) {
    return err
  }
}
const downloadFile = ({ data, fileName, fileType }) => {
  const blob = new Blob([data], { type: fileType })

  const a = document.createElement('a')
  a.download = fileName
  a.href = window.URL.createObjectURL(blob)
  const clickEvt = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
  })
  a.dispatchEvent(clickEvt)
  a.remove()
}

const removedCols = ['logo']
const r = [
  'created_at',
  'user_id',
  'status',
  'rank',
  'score',
  'submission_timestamp',
  'cohort_id',
  'agreement',
  'user_full_name',
  'user_email',
  // 'user_company_country',
  'user_address',
  'user_phone',
  'user_hear_type',
  'user_referrer',
  'ai_forge_city',
  'visa_requirements_city',
  'company_name',
  'sectors',
  'stage',
  'attendance_type',
  'website',
  'twitter',
  'linkedin',
  'business_idea',
  'value_proposition',
  'use_of_ai',
  'competitor_research',
  'edge_success',
  'revenue_streams',
  // 'documents',
  // 'business_idea_rank',
  // 'competitor_research_rank',
  // 'document_rank',
  // 'pitch_deck_file',
  // 'additional_files',
  // 'pitch_analysis',
  'program_type',
  'company_status',
  'youtube',
  // 'logo',
]
function parseStringOrReturnIt(input) {
  try {
    // Try to parse the input as JSON
    return JSON.parse(input)
  } catch (e) {
    // If parsing fails, return the original input
    return input
  }
}
function normalizeCountry(country) {
  if (typeof country === 'object' && (country.value || country.label)) {
    return country.value || country.label
  }
  return country // Assuming it's already a string if not an object with value/label
}
const exportToCsv = (e, data, title = null, withFilter = true) => {
  // console.log('exportToCsv', data, title)
  e.preventDefault()
  // Assuming data is an array of objects and each object is a row
  if (data.length === 0) {
    return // Nothing to export
  }

  // Determine columns either from the first item or receive them as an argument
  const columns = Object.keys(data[0]).filter(
    (column) => !removedCols.includes(column),
  )

  // Prepare headers (column names)
  const headers = columns.join(',')

  // Prepare data rows
  const rows = withFilter
    ? data
        .filter((item) => item?.id)
        .map((item) => {
          return columns
            .map((column) => {
              let cell = item[column]
              if (!cell || cell === undefined) {
                return ''
              }
              if (column === 'user_company_country') {
                const c = parseStringOrReturnIt(cell)?.value || cell
                cell = normalizeCountry(c)
              }
              // Check if the cell contains an object or array and convert it to a JSON string
              else if (typeof cell === 'object') {
                // Convert object/array to JSON string and escape double quotes
                cell = JSON.stringify(cell).replace(/"/g, '""')
                // Optionally, you could format the JSON string to remove quotes or braces for readability
                // cell = JSON.stringify(cell, null, 2).replace(/"/g, '').replace(/[\{\}\[\]]/g, '');
              } else {
                // Convert to string and escape double quotes for standard cells
                cell = cell.toString().replace(/"/g, '""')
              }
              // Enclose the cell in double quotes if it contains commas, double quotes, or line breaks
              if (cell.search(/("|,|\n)/g) >= 0) {
                cell = `"${cell}"`
              }
              return cell
            })
            .join(',')
        })
    : data.map((item) => {
        return columns
          .map((column) => {
            let cell = item[column]
            if (!cell || cell === undefined) {
              return ''
            }
            if (column === 'user_company_country') {
              const c = parseStringOrReturnIt(cell)?.value || cell
              cell = normalizeCountry(c)
            }
            // Check if the cell contains an object or array and convert it to a JSON string
            else if (typeof cell === 'object') {
              // Convert object/array to JSON string and escape double quotes
              cell = JSON.stringify(cell).replace(/"/g, '""')
              // Optionally, you could format the JSON string to remove quotes or braces for readability
              // cell = JSON.stringify(cell, null, 2).replace(/"/g, '').replace(/[\{\}\[\]]/g, '');
            } else {
              // Convert to string and escape double quotes for standard cells
              cell = cell.toString().replace(/"/g, '""')
            }
            // Enclose the cell in double quotes if it contains commas, double quotes, or line breaks
            if (cell.search(/("|,|\n)/g) >= 0) {
              cell = `"${cell}"`
            }
            return cell
          })
          .join(',')
      })

  // Combine headers and rows, then initiate download
  const csvContent = [headers, ...rows].join('\n')
  downloadFile({
    data: csvContent,
    fileName: title || 'applications.csv',
    fileType: 'text/csv',
  })
}

const checkHasAccessToApplication = async (supabase, userId, companyId) => {
  const response = await supabase
    .from('company_team')
    .select('company_id')
    .eq('invitation_status', 'Accepted')
    .eq('member_id', userId)
    .eq('company_id', companyId)

  // Return true if any invitations are found
  return response?.data?.length > 0
}

// You need an async context to use await
const isSuperAdmin = (session) =>
  session?.user?.app_metadata?.claims_admin === 'super-admin' ||
  session?.user?.app_metadata?.claims_admin === 'admin'
const handleCheckAccessINSubmit = async (supabase, session, data, companyID = null) => {
  if (isSuperAdmin(session)) {
    return true
  }
  
  if (!session) {
    return false
  }
  
  // If companyID is provided, use it to check access
  const companyIdToCheck = companyID || data?.id || data?.companyID
  
  if (!companyIdToCheck) {
    // If no company ID available, check if user is owner via data.user_id
    if (data?.user_id === session.user.id) {
      return true
    }
    // If we can't determine access, return false for safety
    return false
  }
  
  // Check if user is the owner
  const { data: company } = await supabase
    .from('company_summary')
    .select('user_id')
    .eq('id', companyIdToCheck)
    .single()
  
  if (company?.user_id === session.user.id) {
    return true
  }
  
  // Check if user has accepted team membership
  const hasAccess = await checkHasAccessToApplication(
    supabase,
    session.user.id,
    companyIdToCheck,
  )
  
  return hasAccess
}

const calculateAndStoreGlobalScore = async (supabase, applicationID) => {
  try {
    // Fetch data from Supabase
    const { data, error } = await supabase
      .from('applications')
      .select('business_idea_rank,competitor_research_rank,pitch_analysis')
      .eq('id', applicationID)
      .single()

    if (error) {
      console.error('Error fetching data:', error)
      return
    }

    const { business_idea_rank, competitor_research_rank, pitch_analysis } =
      data

    const overallScore = (pitchData) => {
      const executionAndTractionScore =
        pitchData?.executionAndTractionScore || 0
      const financialPlanningScore = pitchData?.financialPlanningScore || 0
      const innovationAndViabilityScore =
        pitchData?.innovationAndViabilityScore || 0
      const marketFitAndGrowthPotentialScore =
        pitchData?.marketFitAndGrowthPotentialScore || 0

      const rawScore =
        (executionAndTractionScore +
          financialPlanningScore +
          innovationAndViabilityScore +
          marketFitAndGrowthPotentialScore) /
        4

      return Math.round(rawScore) || pitchData?.finalAssessmentScore || 0
    }

    const finalAssessmentScore = overallScore(pitch_analysis)
    const competitorFeedbackRating = competitor_research_rank?.ratings
    const analysedFeedbackRating = business_idea_rank?.ratings

    const isScoreCalculable =
      analysedFeedbackRating !== null &&
      competitorFeedbackRating !== null &&
      finalAssessmentScore !== null

    if (isScoreCalculable) {
      const newGlobalScore =
        (analysedFeedbackRating +
          competitorFeedbackRating +
          finalAssessmentScore) /
        3

      // console.log('Score calculation', isScoreCalculable, newGlobalScore)

      // Update global score in the database
      if (applicationID) {
        updateGlobalScoreInDB(supabase, newGlobalScore, applicationID)
      }
    }
  } catch (e) {
    console.log('error', e)
  }
}
const updateGlobalScoreInDB = async (supabase, score, applicationID) => {
  try {
    // const updateResponses = await supabase
    //   .from('applications')
    //   .update({ score })
    //   .eq('id', applicationID)
    const rank = await fetchApplicationRank(supabase, applicationID, score)

    // const updateResponse = await supabase
    //   .from('applications')
    //   .update({ rank })
    //   .eq('id', applicationID)

    // if (updateResponse.error) {
    //   throw new Error(
    //     `Error updating global score: ${updateResponse.error.message}`,
    //   )
    // }
  } catch (err) {
    // Log any errors that occur during the score update
    console.error(err.message || 'An error occurred during the score update.')
  }
}
const updateRankByadmin = async (applicationID, score) => {
  try {
    const response = await fetch('/api/apps-rank', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ applicationID, score }),
    })

    const result = await response.json()
    // console.log('result:', result)
    return result
  } catch (error) {
    console.error('Unexpected error:', error)
    return {
      status: 'error',
      message: 'Unexpected error occurred.',
      error: error,
    }
  }
}
const fetchApplicationRank = async (supabase, applicationID, score) => {
  // const { data, error } = await supabase.rpc(
  //   'update_and_return_specific_new_rank',
  //   {
  //     specific_application_id: applicationID,
  //   },
  // )
  const { data, error } = await updateRankByadmin(applicationID, score)

  if (error) {
    console.log('Error fetching application rank:', error)
    return
  }

  if (data && data.length > 0) {
    const req = data[0]
    // console.log('req?.application_new_rank', req?.application_new_rank)
    return req?.application_new_rank || null
  } else {
    console.log('Application not found or no rank available.')
    return null
  }
}

const updateUserByadmin = async (userID, obje, isDelete) => {
  try {
    const response = await fetch('/api/supabase-admin', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userID, obje, isDelete }),
    })

    const result = await response.json()

    if (response.ok) {
      console.log('Success:', result)
      return { status: 'success', data: result }
    } else {
      console.error('Error:', result)
      return { status: 'error', message: result.message, error: result }
    }
  } catch (error) {
    console.error('Unexpected error:', error)
    return {
      status: 'error',
      message: 'Unexpected error occurred.',
      error: error,
    }
  }
}
const createNewChatByAdmin = async (obj) => {
  try {
    const response = await fetch('/api/create-new-chat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ obje: obj }),
    })

    const result = await response.json()

    if (response.ok) {
      // console.log('Success:', result)
      return result?.data
    } else {
      console.error('Error:', result)
      return { status: 'error', message: result.message, error: result }
    }
  } catch (error) {
    console.error('Unexpected error:', error)
    return {
      status: 'error',
      message: 'Unexpected error occurred.',
      error: error,
    }
  }
}

async function getEmbedding(text) {
  const response = await fetch('/api/embeddings', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ text }),
  })

  if (!response.ok) {
    const error = await response.json()
    console.error('Error:', error)
    throw new Error(error.error || 'Failed to fetch embedding')
  }

  const { embedding } = await response.json()
  return embedding
}

const getApplyRedirectUrl = (session) => {
  const isFounder = session?.user?.app_metadata?.role === 'founder'
  if (!session) {
    return '/signup?role=founder'
  }
  if (isFounder) {
    return '/i/applications/new'
  }
  return '/i/profile'
}

export {
  getFirstCharsOfName,
  calculateReadingTime,
  getPreviousWeekDates,
  getWordsCount,
  createHubspotContact,
  exportToCsv,
  handleCheckAccessINSubmit,
  calculateAndStoreGlobalScore,
  updateUserByadmin,
  createNewChatByAdmin,
  getEmbedding,
  getApplyRedirectUrl,
}
